import {entityType} from "./module";
import {createGetAllMethod, createPostMethod} from "reactcoregk/store/actions";
import {getDefaultApiHandler} from "../../helpers/utils";

export const getAllUsers = (params) => createGetAllMethod(entityType, params, getDefaultApiHandler())
export const insertUsers = (payload) => createPostMethod(entityType, payload, getDefaultApiHandler())
